<template>
  <saved-cards />
</template>

<script>
import SavedCards from '../ProfileInfo/SavedCards'
export default {
  name: 'MobileSavedCard',
  components: {
    SavedCards,
  },
}
</script>

<style></style>
